import * as React from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import DataContext from "../../Context/DataContext";

export default function CustomFieldFormat({
  id,
  name,
  title,
  type,
  required,
  value,
  defaultValue,
  error,
  helper_text,
  handleFunction,
  rowId,
  multiple,
  sectionTitle,
  disabled = false,
  dynamicDate,
  style,
  endIcon,
  startIcon,
  minAccept,
  maxAccept,
}) {
  const { handleDynamicDates } = React.useContext(DataContext);

  const handledateChange = (dateVal) => {
    const date = new Date(dateVal?.$d);
    const dd = date?.getDate();
    const mm = date?.getMonth() + 1;
    const yy = date?.getFullYear();
    const value =
      `${yy}-${mm <= 9 ? `0${mm}` : mm}-${dd <= 9 ? `0${dd}` : dd}` ||
      undefined;

    if (dynamicDate) {
      handleDynamicDates(value, id, rowId, name, sectionTitle);
    } else {
      handleFunction(name, value);
    }
  };

  return (
    <>
      <div
        style={{
          fontSize: "16px",
          textAlign: "start",
          padding: "0 6px",
          color: "gray",
        }}
      >
         <span style={{ padding: "0 4px", color: "#6e6e6e" }}>
        <label>{title}{required && <span style={{color:'red'}}>*</span>}</label>
      </span>
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer sx={{ padding: "4px" }} components={["DateField"]}>
          <div
            style={{
              marginBottom: "4px",
              display: "flex",
              flexDirection: "column",
              padding: "0px",
            }}
          >
            <DatePicker
              key={id}
              //   label={title}
              name={name}
              disabled={disabled}
              helperText={helper_text}
              disableFuture
              required={required}
              onChange={(value) => handledateChange(value)}
              format="DD-MM-YYYY"
              error={helper_text}
              sx={{ padding: "0px" }}
              slotProps={{
                textField: { size: "small", fullWidth: true },
                inputLabel: { shrink: true },
              }}
            />
            {helper_text && (
              <span
                style={{
                  color: "#df1111",
                  width: "100%",
                  textAlign: "start",
                  margin: "4px 0",
                  fontSize: "13px",
                  fontFamily: "sans-serif",
                  padding: "0 12px",
                }}
              >
                {helper_text}
              </span>
            )}
          </div>
        </DemoContainer>
      </LocalizationProvider>
    </>
  );
}
